module.exports = __webpack_public_path__ + "img/MAP4.ff0aefb9.jpeg";